import {Grid} from "@mui/material"
import React, {useContext} from "react"
import {DataContext} from "../../../context/DataContextProvider"
import {getMerkmal} from "../../../../anwendungskonfigurator/misc/widget-functions"
import BereicheItem from "./ListItemsManagerWidget/BereicheItem"

const BereicheWidget = ({widget}) => {
    const {getDataFromPointer} = useContext(DataContext)
    const risikoortList = getDataFromPointer(getMerkmal(widget)?.pointer)
    return (
        <Grid
            container
            spacing={1}
            p={1}
            sx={{border: "1px solid #dee2e6", backgroundColor: "#f8f9fa"}}
        >
            {risikoortList?.map((risikoortListEntry, index) => (
                <Grid item key={risikoortListEntry + index}>
                    <BereicheItem risikoortListEntry={risikoortListEntry} />
                </Grid>
            ))}
        </Grid>
    )
}

export default BereicheWidget
